import { z } from 'zod';
import { zfd } from 'zod-form-data';
import { orderContext } from '~/app/features/order-middleware/orderMiddleware';
import { makeAction, makeLoader, redirect } from '~/utils/routing';
import { shippingClaimContext } from '../shippingClaimMiddleware';

export const { loader, useLoaderData } = makeLoader(({ context }) => {
  const order = context.get(orderContext);
  const shippingProtectionClaim = context.get(shippingClaimContext);

  return {
    items: order.lineItems.filter((item) => !item.isCorsoProduct),
    selectedItemIds: shippingProtectionClaim.itemIds,
  };
});

const schema = zfd.formData({
  items: zfd.repeatable(z.array(zfd.numeric()).min(1)),
});

export const { action, useActionResult } = makeAction(
  ({ formData }, appStore) => {
    const result = schema.safeParse(formData);

    if (!result.success) {
      return {
        ok: false,
        message: 'Please select the order items affected.',
      };
    }

    appStore.dispatch(
      appStore.actions.shippingProtectionClaim.setItemIds(result.data.items),
    );

    return redirect('../meta');
  },
);
